// @flow strict
import { Alert, Col, Row } from 'antd';
import * as React from 'react';

function StatsItem({ data }) {
  const alertItems = [
    { title: 'Total Users', key: 'all_user', type: 'info' },
    { title: 'Today', key: 'today', type: 'info' },
    { title: 'This Month', key: 'this_month', type: 'info' },
    { title: 'This Year', key: 'this_year', type: 'info' },
    { title: 'Active Subscribers', key: 'activeSubscriptions', type: 'info' },
    { title: 'Cancel Subscribers', key: 'cancelledSubscriptions', type: 'info' },
    { title: 'Paused Subscribers', key: 'pausedSubscriptions', type: 'info' },
  ];

  return (
    <Row
      gutter={[
        { xs: 8, md: 12, lg: 16 },
        { xs: 8, md: 12, lg: 16 }
      ]}
    >
      {alertItems.map(item => (
        (data[item.key] || data[item.key] === 0) && (
          <Col key={item.key} lg={6} md={8} sm={12} xs={24}>
            <Alert
              message={<h6>{item.title}</h6>}
              description={<h3>{data[item.key]}</h3>}
              type={item.type}
              className="text-center"
            />
          </Col>
        )
      ))}
    </Row>
  );
};

export default StatsItem;
